import createContract from "./createContract";
import payrollAbi from "../forwarderproxy.json";
import erc20Abi from "../erc20.json";

import transactionFee from "./getTransactionFee";

import Web3 from "web3";


export async function bulkSend(
  amounts,
  addresses,
  batchId,
  walletAddress,
  decimals,
  currencyAddress,
  fee,
  network
) {
  try {
    const results = [];
    const BATCH_SIZE = 200; // Define batch size
    const totalBatches = Math.ceil(addresses.length / BATCH_SIZE);
    const WEB3 = new Web3(window.ethereum);

    // Convert decimals to BigInt factor
    const num = BigInt(Math.pow(10, Number(decimals)));

    // Map amounts to uint256 values
    const amountRecordsToSend = amounts.map((x) => {
      try {
        // Convert to smallest unit
        const rawAmount = parseFloat(x);
        if (isNaN(rawAmount)) {
          throw new Error(`Invalid amount: ${x}`);
        }
        
        // Calculate the scaled amount with proper decimal handling
        const scaledAmount = BigInt(Math.floor(rawAmount * (10 ** Number(decimals)))).toString();
        
        console.log('Amount conversion:', {
          original: x,
          rawAmount,
          scaled: scaledAmount
        });
        return scaledAmount;
      } catch (error) {
        console.error('Amount conversion error:', error);
        throw error;
      }
    });

    // Create an ERC-20 contract instance
    const erc20Contract = new WEB3.eth.Contract(erc20Abi, currencyAddress);

    for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
      const start = batchIndex * BATCH_SIZE;
      const end = Math.min(start + BATCH_SIZE, addresses.length);

      console.log(batchId, "batchId")

      // Prepare batch data
      const batchAddresses = addresses.slice(start, end);
      const batchAmounts = amountRecordsToSend.slice(start, end).map(BigInt); // Ensure BigInt conversion
      const batch = batchId + batchIndex; // Sequential batch IDs

      // Calculate total batch amount in wei
      const batchTotalAmount = batchAmounts.reduce((sum, x) => sum + x, BigInt(0));
      
      // Check allowance
      const allowance = await erc20Contract.methods
        .allowance(walletAddress, network.FORWARDER_ADDRESS)
        .call();
      console.log(`Batch ${batchIndex + 1} Allowance: `, allowance);
      console.log(`Batch ${batchIndex + 1} Required Amount: `, batchTotalAmount.toString());
      
      // Check if allowance is sufficient for this batch
      if (BigInt(allowance) < batchTotalAmount) {
        console.error(`Insufficient allowance for batch ${batchIndex + 1}. Required: ${batchTotalAmount.toString()}, Available: ${allowance}`);
        throw new Error(`Insufficient token allowance for batch ${batchIndex + 1}. Please approve more tokens.`);
      }

      // Calculate fee for the batch using the same method as the test
      const bulkSenderContract = await createContract(
        payrollAbi,
        network.FORWARDER_PROXY_ADDRESS
      );
      
      const calculatedFee = await bulkSenderContract.methods
        .getTransactionFee(batchAddresses.length)
        .call();
        
      console.log(`Batch ${batchIndex + 1} Calculated Fee:`, calculatedFee.toString());
      console.log(
        "Total Batch Amount: ",
        batchAmounts.reduce((sum, x) => sum + x, BigInt(0)) // Proper BigInt addition
      );

      try {
        // Validate forwarder proxy address
        if (!WEB3.utils.isAddress(network.FORWARDER_PROXY_ADDRESS)) {
          throw new Error('Invalid forwarder proxy address');
        }

        if (!bulkSenderContract || !bulkSenderContract.methods) {
          throw new Error('Failed to create bulk sender contract');
        }

        // Log amounts like in the test
        console.log("Amounts:", batchAmounts.map(a => a));
        
        // Estimate gas for the transaction (same as test)
        const gasEstimate = await bulkSenderContract.methods
          .distributeToken(batch, currencyAddress, batchAddresses, batchAmounts)
          .estimateGas({
            from: walletAddress,
            value: calculatedFee
          });
        
        console.log("Estimated gas:", gasEstimate.toString());

        // Add 20% buffer to gas estimate (same as test)
        const gasLimitWithBuffer = Math.floor(Number(gasEstimate) * 1.2);

        // Send transaction with updated parameters
        const tx = await bulkSenderContract.methods
          .distributeToken(
            batch,
            currencyAddress,
            batchAddresses,
            batchAmounts
          )
          .send({
            from: walletAddress,
            value: calculatedFee,
            gasLimit: gasLimitWithBuffer
          });
          
        // tx is already the receipt in Web3.js
        const receipt = tx;
        console.log("Actual gas used:", receipt.gasUsed.toString());
        console.log("Gas efficiency (Estimated/Actual):", 
          (Number(gasEstimate) / Number(receipt.gasUsed) * 100).toFixed(2) + "%");

        // Log transaction events like in the test
        if (receipt.logs) {
          for (const event of receipt.logs) {
            try {
              // For Web3.js, we need to decode events differently
              console.log('Event log:', event);
            } catch (e) {
              // Skip events we can't decode
            }
          }
        }

        const result = receipt;

        console.log(`Batch ${batchIndex + 1} succeeded`, result);
        results.push({ batchIndex: batchIndex + 1, status: true, result });
      } catch (error) {
        console.log(`Batch ${batchIndex + 1} failed`, error);
        results.push({
          batchIndex: batchIndex + 1,
          status: false,
          error: error.message,
        });
      }

    }

    return results; // Return all batch results
  } catch (error) {
    console.error("Error processing batches:", error);
    throw error;
  }
}




export async function bulkSendNative(
  amounts,
  addresses,
  batchId,
  walletAddress,
  fee,
  network
) {
  try {
    const results = [];
    const BATCH_SIZE = 300;
    const totalBatches = Math.ceil(addresses.length / BATCH_SIZE);
    const WEB3 = new Web3(window.ethereum);
    console.log(network.nativeCurrency.decimals, "dsjdksjdjk")
    const num = BigInt(Math.pow(10, Number(network.nativeCurrency.decimals)));

    const convertToWei = (value) =>
      (num * BigInt(Math.floor(value * 10 ** 18)) / BigInt(10 ** 18)).toString();

    const amountRecordsToSend = amounts.map(convertToWei);

    for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
      const start = batchIndex * BATCH_SIZE;
      const end = Math.min(start + BATCH_SIZE, addresses.length);

      const batchAddresses = addresses.slice(start, end);
      const batchAmounts = amountRecordsToSend.slice(start, end);
      const batch = batchIndex == 0? batchId: batchId-batchIndex;
      console.log(network.chainId,"chhh")

      // Calculate fee for the batch - use same method as bulkSend
      const bulkSenderContract = await createContract(
        payrollAbi,
        network.FORWARDER_PROXY_ADDRESS
      );
      
      const calculatedFee = await bulkSenderContract.methods
        .getTransactionFee(batchAddresses.length)
        .call();
        
      console.log(`Batch ${batchIndex + 1} Calculated Fee:`, calculatedFee.toString());
      console.log("Fee details:", calculatedFee)
      const batchTotalAmount = batchAmounts.reduce(
        (total, amt) => total + BigInt(amt),
        BigInt(0)
      ) + BigInt(calculatedFee);

      try {
        // Validate forwarder proxy address
        if (!WEB3.utils.isAddress(network.FORWARDER_PROXY_ADDRESS)) {
          throw new Error('Invalid forwarder proxy address');
        }

        if (!bulkSenderContract || !bulkSenderContract.methods) {
          throw new Error('Failed to create bulk sender contract');
        }

        // Log amounts like in the test
        console.log("Native Amounts:", batchAmounts.map(a => a.toString()));
        
        // Estimate gas for the transaction
        const gasEstimate = await bulkSenderContract.methods
          .distributeNativeCoin(batch, batchAddresses, batchAmounts)
          .estimateGas({
            from: walletAddress,
            value: batchTotalAmount.toString(),
          });
        
        console.log("Estimated gas:", gasEstimate.toString());

        // Add 20% buffer to gas estimate (same as test)
        const gasLimitWithBuffer = Math.floor(Number(gasEstimate) * 1.2);

        const result = await bulkSenderContract.methods
          .distributeNativeCoin(batch, batchAddresses, batchAmounts)
          .send({
            from: walletAddress,
            value: batchTotalAmount.toString(),
            gasLimit: gasLimitWithBuffer,
          });
          
        // result is already the receipt in Web3.js
        const receipt = result;
        console.log("Actual gas used:", receipt.gasUsed.toString());
        console.log("Gas efficiency (Estimated/Actual):", 
          (Number(gasEstimate) / Number(receipt.gasUsed) * 100).toFixed(2) + "%");

        console.log(`Batch ${batchIndex + 1} succeeded`, result);
        results.push({ batchIndex: batchIndex + 1, status: true, result });
      } catch (error) {
        console.log(`Batch ${batchIndex + 1} failed`, error);
        results.push({
          batchIndex: batchIndex + 1,
          status: false,
          error: error.message,
        });
      }
    }

    return results; // Return all batch results
  } catch (error) {
    console.error("Error processing batches:", error);
    throw error;
  }
}


// export async function bulkSendNative(
//   amounts,
//   addresses,
//   batchId,
//   walletAddress,
//   fee,
//   network,
// ) {
//   try {
//     const bulkSenderContract = await createContract(
//       payrollAbi,
//       network.FORWARDER_PROXY_ADDRESS
//     );
//     const num = BigInt(Math.pow(10, Number(network.nativeCurrency.decimals)));
//     const WEB3 = new Web3(window.ethereum);

//     // Convert amounts to integer values in wei
//     const amountRecordsToSend = amounts.map(x => (num * BigInt(Math.floor(x * 10**18)) / BigInt(10**18)).toString());
//     let totalAmount = BigInt(0);

//     for (let i = 0; i < amounts.length; i++) {
//       totalAmount += (num * BigInt(Math.floor(amounts[i] * 10**18)) / BigInt(10**18));
//     }

//     const nonce = await WEB3.eth.getTransactionCount(walletAddress);
//     console.log(fee.transactionFee);

//     // Ensure fee is also an integer and add it to totalAmount
//     totalAmount += BigInt(fee.transactionFee) + BigInt(300000);
//     console.log({ totalAmount: totalAmount.toString() }, nonce);

//     const gasEstimate = await bulkSenderContract.methods
//       .distributeNativeCoin(batchId, addresses, amountRecordsToSend)
//       .estimateGas({
//         from: walletAddress,
//         value: totalAmount.toString(),
//         nonce: nonce,
//       });

//     const result = await bulkSenderContract.methods
//       .distributeNativeCoin(batchId, addresses, amountRecordsToSend)
//       .send({
//         from: walletAddress,
//         value: totalAmount.toString(),
//         gas: gasEstimate,
//       });

//     console.log({ result });

//     return result;
//   } catch (error) {
//     console.log({ error });

//     return error;
//   }
// }



// export async function bulkSendNative(
//   amounts,
//   addresses,
//   batchId,
//   walletAddress,
//   fee,
//   network,
// ) {
//   try {
//     const bulkSenderContract = await createContract(
//       payrollAbi,
//       network.forwarderProxyAddress
//     );
//     console.log({amounts,
//       addresses,
//       batchId,
//       walletAddress,
//       fee,
//       network})
//     var num = Math.pow(10, Number(network.nativeCurrency.decimals));
//     let WEB3 = new web3(window.ethereum);
//     let amountRecordsToSend = amounts.map((x) => (num * x).toString());
//     let totalAmount = 0
//     for (let i = 0; i < amounts.length; i++) {
//       totalAmount = totalAmount + (amounts[i] * num);
//     }

//     const nonce = await WEB3.eth.getTransactionCount(walletAddress)
//     console.log(fee.transactionFee)
//     totalAmount = totalAmount + Number(fee.transactionFee) + 300000
//     console.log({totalAmount}, nonce)

//     let gasEstimate = await bulkSenderContract.methods
//     .distributeNativeCoin(batchId, addresses, amountRecordsToSend)
//     .estimateGas({
//       from: walletAddress,
//       value: totalAmount,
//       nonce: nonce
//     });

//     let result = await bulkSenderContract.methods
//       .distributeNativeCoin(batchId, addresses, amountRecordsToSend)
//       .send({
//         from: walletAddress,
//         value: totalAmount,
//         gas: gasEstimate
//       });

//       console.log({result})

//     return result;
//   } catch (error) { 
//     console.log({error})

//     return error;
//   }
// }
